// Example service: filepath: /home/boss/workspace/pwa/zgrana/src/app/services/example.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { DataProcessingService } from './data-prcessing.service';
import { LoggerService } from './logger.service';
import { CurrentActiveLayout, EditLayout, Layout } from '../interfaces/layouts.interface';

@Injectable({ providedIn: 'root' })
export class LayoutsService {
   private get apiUrl(): string {
     return this.loggerService.resolveApiUrl('layouts');
   }

   constructor(
     private http: HttpClient,
     private dataProcess: DataProcessingService,
     private loggerService: LoggerService
   ) {}

  getLayouts(params?: {
    order_by?: string;
    order?: string;
    skip?: number;
    limit?: number;
    [key: string]: any; // for filters
  }): Observable<GenericResponseWithTotal<Layout>> {
    params = params || {};// Default to active partners
    return this.http.get<GenericResponseWithTotal<Layout>>(this.apiUrl, { params: this.dataProcess.fitlerParams(params) });
  }

  getLayout(idOrTag: number | string): Observable<Layout> {
    return this.http.get<Layout>(`${this.apiUrl}/${idOrTag}`);
  }

  getCurrentLayout(): Observable<CurrentActiveLayout> {
    return this.http.get<CurrentActiveLayout>(`${this.apiUrl}/current`);
  }

  updateLayout(id: number, data: EditLayout): Observable<Layout> {
    return this.http.put<Layout>(`${this.apiUrl}/${id}`, data);
  }

  createLayout(data: Partial<EditLayout>): Observable<Layout> {
    return this.http.post<Layout>(this.apiUrl, data);
  }

  deleteLayout(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

}